import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=0a06da24&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"
import style0 from "./Address.vue?vue&type=style&index=0&id=0a06da24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06da24",
  null
  
)

export default component.exports